import styled from 'styled-components';

import {
  fieldVariables,
  inputContainerSizeStyles,
  inputContainerStyles,
  inputFocus,
} from '@xemplo/input-utils';
import { Colour, Shadow } from '@xemplo/style-constants';
import { XemploInput } from '@xemplo/xemplo-input';
import { zIndex } from '@xemplo/zindex';

export const ComponentWrapper = styled.div`
  ${fieldVariables};
  width: var(--input-width);
`;

export const FieldWrapper = styled.div`
  ${inputContainerStyles};
  ${inputContainerSizeStyles};
  border: none;
  gap: 0;

  &.invalid {
    --input-border-color: ${Colour.Clarity.Red.Hard};
    ${Shadow.Error2};
  }

  &:has(input:not(:focus, .has-placeholder, .has-value), input.label-hidden) {
    padding: 20px 16px;

    &.no-padding-inline {
      padding: 20px 0px;
    }
  }

  &.no-padding-inline {
    padding-inline: 0;
  }
`;

/**
 * Custom styled XemploInput for DateField component.
 * It overrides some of the border styling so we can
 * combine it with the DateSelector component and
 * have the look & feel of a single input field.
 *
 * It also handles the focus and invalid states.
 */
export const CustomXemploInput = styled(XemploInput)`
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;

  &:focus-within:not(.invalid) {
    ${inputFocus};
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    z-index: ${zIndex.FormField};
  }

  &.invalid {
    border-right-color: ${Colour.Gray[200]};
    box-shadow: none;
  }

  &.xemplo-input-container {
    gap: 4px;

    & > label.left {
      left: 16px;
    }
  }
`;
